import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/currency",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "currency-page",
        component: () => import("@/views/Currency/CurrencyPage.vue"),
        meta: {
          title: "Currency",
          titleLocalizationCode: "Currency",
          desc: "Currency page",
          descLocalizationCode: "Currency_Page",
          sidebarElement: false,
          permissionCodes: [
            // "CostCenter.Read",
          ],
        },
      },
    ],
  },
];
